import { quickOrderProductListStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ArrowLeft from "@insite/mobius/Icons/ArrowLeft";
import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(quickOrderProductListStyles, {
    ...quickOrderProductListStyles,
    quantityOrdered: {
        labelPosition: "left",
        labelProps: {
            css: css`
                width: auto;
                display: inline-flex;
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                width: 70px;
            `,
            formField: css`
                input {
                    padding: 0 9px !important;
                    text-align: center;
                }
            `,
        },
    },
});

merge(quickOrderProductListStyles, {
    quantityGridItem: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-right: 0;
                        `,
                    ],
                    "max",
                )}
        `,
    },

    addToListLink: {
        link: {
            typographyProps: {
                css: css`
                    display: none;
                `,
            },
        },
    },
});
